import { render, staticRenderFns } from "./ProductOptions.vue?vue&type=template&id=274e8fd8&"
import script from "./ProductOptions.vue?vue&type=script&lang=js&"
export * from "./ProductOptions.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductOptions.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "155139fb"
  
)

export default component.exports